import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadRollbackPlansBegin,
  loadRollbackPlansFailed,
  loadRollbackPlansSuccessful,

} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import {
  BACKEND_URL_V2, DEFAULT_ITEMS_OF_PAGE,
} from '../../../configs';

export default function* loadRollbackPlans(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      id,
    } = payload;
    const pool = {
      limit,
      page,
    };
    const url = `${BACKEND_URL_V2}/audit/rollback-plans/${id}/items`;
    yield put(loadRollbackPlansBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadRollbackPlansSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadRollbackPlansFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadRollbackPlansFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
